import React, { useContext, useState } from "react";
import { Button, Container, H2, Section } from "../../Styles/Global.Styled";
import ArrowIcon from "../../Icons/ArrowIcon";
import ProductSummary from "../Product/ProductSummary";
import { css } from "styled-components";
import { CartContext } from "../../Context/CartContext";

const cartItemsSection = css`
  gap: 1vh;
`;
const hideDisplay = css`
  display: none;
`;
const toggleBttn = (hide) => css`
  display: ${hide ? "flex" : "none"};
`;
const sectionHeader = css`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => theme.main};
  font-size: 2.2vh;
`;
const mbFontSize = css`
  font-size: 2vh;
`;
const sectionMbStyle = css`
  box-shadow: 0 0 2px 2px ${({ theme }) => theme.main};
  padding: 2vh;
  border-radius: 12px;
`;
const labelsCntStyle = css`
  flex-direction: column;
  gap: 1vh;
`;

const CartItems = ({ toggle = false, isManagable = false }) => {
  const { cart } = useContext(CartContext);
  const [isCartOpen, setCartOpen] = useState(!toggle);

  return (
    <Section $baseStyle={cartItemsSection} $mStyle={toggle && sectionMbStyle}>
      <H2 $baseStyle={sectionHeader} $mStyle={mbFontSize}>
        Your Cart items
        <Button
          $baseStyle={hideDisplay}
          $mStyle={toggleBttn(toggle)}
          onClick={() => setCartOpen(!isCartOpen)}
        >
          <ArrowIcon direction={isCartOpen && "up"} />
        </Button>
      </H2>
      <Container
        $baseStyle={labelsCntStyle}
        $mStyle={!isCartOpen && hideDisplay}
      >
        {cart.map((cartItem) => (
          <ProductSummary product={cartItem} isManagable={isManagable} />
        ))}
      </Container>
    </Section>
  );
};

export default CartItems;
